<template>
  <div class="card card-chat-booking float-left ml-3" v-if="checkoutConditions">
    <div class="card-body">
       <!-- Photo attachment -->
      <div class="pb-3" v-if="checkoutConditions && checkoutConditions.allow_photo_attachment">
        <label for="remark">
          {{ checkoutConditions.required_photo_attachment ? $t('message.booking.checkout_step.attach_photos') : $t('message.booking.checkout_step.attach_photos_not_required') }}
        </label>
        <div class="text-remark mb-2">
          {{ ($i18n.locale === 'th') ? checkoutConditions.photo_attachment_remark_th : checkoutConditions.photo_attachment_remark_en }}
        </div>
        <vue-dropzone ref="vueDropzone"
                      id="dropzone"
                      class="dropzone-dashed"
                      :destroyDropzone="false"
                      :options="dropzoneOptions"
                      @vdropzone-sending="vueDropZoneAddParams"
                      @vdropzone-removed-file="vueDropZoneRemovedFile"
                      @vdropzone-mounted="vueDropZoneMounted"
                      @vdropzone-success="vueDropZoneSuccess" />
        <div class="mt-2 text-remark -status-alert" v-if="hasError">
          <i class="fas fa-exclamation-triangle"></i> {{ $t('message.required_photo_attachment') }}
        </div>
      </div>

      <!-- Remark -->
      <div class="form-group">
        <label for="remark">
          {{ $t('message.service_request.big_cleaning_remark') }}
        </label>
        <textarea rows="3"
                  ref="remark"
                  id="remark"
                  :placeholder="$t('message.service_request.deep_cleaning_remark')"
                  class="form-control textarea-jumbo"
                  v-model="remark"></textarea>
      </div>
      <div class="text-small text-orange pb-2" v-if="checkoutConditions.service_remark_title_th">
        {{ ($i18n.locale === 'th') ? checkoutConditions.service_remark_title_th : checkoutConditions.service_remark_title_en }}
      </div>
      <div class="text-remark" v-if="checkoutConditions.service_remark_detail_th"
        v-html="($i18n.locale === 'th') ? checkoutConditions.service_remark_detail_th : checkoutConditions.service_remark_detail_th">
      </div>
      <div class="pt-3">
        <button class="btn btn-info btn-block" @click="submit()">
          {{ $t('message.button.submit') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import vue2Dropzone from 'vue2-dropzone'
  import axios from 'axios'
  
  export default {
    props: {
      message: Object
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailMethod: 'crop',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
          headers: { 'Content-Type': 'multipart/form-data' },
          addRemoveLinks: true,
          autoProcessQueue: true,
          maxFiles: 20
        },
        count: 0,
        remark: '',
        hasError: false,
        checkoutConditions: null
      }
    },
    computed: {
      ...mapGetters({
        authState: 'auth/getState',
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['bookingData']),
      ...mapState('booking', ['customerAreaPhotos'])
    },
    methods: {
      vueDropZoneAddParams (file, xhr, formData) {
        this.count += 1
        formData.append('count', this.count)
        formData.append('user_id', this.user.id)
      },
      vueDropZoneMounted () {
        const uploadUrl = `${this.$http.options.root}/bookings/add-customer-area-photos`
        this.$refs.vueDropzone.options.url = uploadUrl
        this.$refs.vueDropzone.setOption('url', uploadUrl)
        const headers = { 'Authorization': `Bearer ${this.authState.token}` }
        this.$refs.vueDropzone.options.headers = headers
        this.$refs.vueDropzone.setOption('headers', headers)
      },
      vueDropZoneSuccess (file, response) {
        if (!response.error) {
          const imageUrl = response.image_url
          file.image_url = imageUrl
          this.$store.commit('booking/ADD_CUSTOMER_AREA_PHOTO', imageUrl)
          this.hasError = false
        }
      },
      async vueDropZoneRemovedFile (file, error, xhr) {
        const url = '/bookings/delete-customer-area-photos'
        const imageUrl = file.image_url
        const { data } = await axios.post(url, { image_url: imageUrl })
        if (!data.error) {
          this.$store.commit('booking/DELETE_CUSTOMER_AREA_PHOTO', imageUrl)
        }
      },
      async submit () {
        try {
          if (this.checkoutConditions && this.checkoutConditions.allow_photo_attachment && this.checkoutConditions.required_photo_attachment && this.customerAreaPhotos.length === 0) {
            this.hasError = true
            return true
          }
          let data = `remark=${this.remark}`
          if (this.customerAreaPhotos) {
            data += `&customer_photo_urls=${this.customerAreaPhotos.toString()}`
          }
          const message = {
            sender_type: 'user',
            type: 'text',
            label: 'saved-additional-remark',
            text: 'ยืนยันข้อมูลหมายเหตุเพิ่มเติมแล้ว',
            data: data
          }
          this.$store.commit('chatBooking/ADD_MESSAGE', message)
        } catch (e) {
          console.log('check error message', e.message)
        }
      }
    },
    mounted () {
      this.$store.commit('booking/CLEAR_CUSTOMER_AREA_PHOTOS')
      const serviceId = Number(this.bookingData.service_id)
      const parentServiceId = this.globalState.services[serviceId].parent_id
      const service = (parentServiceId) ? this.globalState.services[parentServiceId] : this.globalState.services[serviceId]
      if (service && service.checkout_conditions) {
        this.checkoutConditions = service.checkout_conditions
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/AdditionalRemarkMessage.vue